import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { CustomerProjectPhaseActivity } from '../../customer-project-phase-activity.interface';
import { User } from '../../user.interface';
import { ApiService } from '../api/api.service';

@Injectable({
    providedIn: 'root',
})
export class CustomerProjectPhaseActivityService {
    constructor(private apiService: ApiService) {}

    assignees(customerId: number) {
        return this.apiService.getCall$<User[]>(`customer-projects/phases/activity/assignees/${customerId}`);
    }

    save(activity: CustomerProjectPhaseActivity) {
        const toSave = {
            ...activity,
            deadline: activity.deadline ? formatDate(activity.deadline, 'yyyy-MM-dd', 'nl-NL') : null,
        };
        return this.apiService.postCall$(`customer-projects/phases/activity`, toSave);
    }

    delete(id: number) {
        return this.apiService.deleteCall$(`customer-projects/phases/activity/${id}`);
    }

    saveOrder(activities: CustomerProjectPhaseActivity[]) {
        const order = activities.map((a, index) => {
            const order = index + 1;
            a.order = order;
            return { id: a.id, order };
        });
        return this.apiService.postCall$('customer-projects/phases/activity/order', { order: order });
    }
}
